var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"}),_c('div',{staticClass:"card-footer"},[_c('p-button',{staticClass:"info",attrs:{"type":"info","round":""},on:{"click":function($event){$event.preventDefault();return _vm.callMonoConnect.apply(null, arguments)}}},[_vm._v("Link a bank account")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }